import { action } from 'typesafe-actions';

import { asyncAction } from 'store/utils/promiseAction';

import {
  LinesMatrixIntegrationTypes,
  LineMatrixIntegrationInterface,
  CreateLineMatrixIntegrationInterface,
  SelectedLinesInterface,
} from './types';

// List Lines Matrix Integration
export const listLinesMatrixIntegrationRequest = (payload: object) =>
  action(
    LinesMatrixIntegrationTypes.LIST_LINES_MATRIX_INTEGRATION_REQUEST,
    payload,
  );

export const listLinesMatrixIntegrationSuccess = (payload: {
  linesMatrixIntegrationList: LineMatrixIntegrationInterface[];
  totalCount: number;
}) =>
  action(
    LinesMatrixIntegrationTypes.LIST_LINES_MATRIX_INTEGRATION_SUCCESS,
    payload,
  );

export const listLinesMatrixIntegrationFailure = () =>
  action(LinesMatrixIntegrationTypes.LIST_LINES_MATRIX_INTEGRATION_FAILURE);

// Get Line Matrix Integration
export const getLineMatrixIntegrationRequest = (payload: object) =>
  asyncAction(
    LinesMatrixIntegrationTypes.GET_LINE_MATRIX_INTEGRATION_REQUEST,
    payload,
  );

export const getLineMatrixIntegrationSuccess = (payload: {
  lineMatrixIntegrationData: LineMatrixIntegrationInterface;
}) =>
  action(
    LinesMatrixIntegrationTypes.GET_LINE_MATRIX_INTEGRATION_SUCCESS,
    payload,
  );

export const getLineMatrixIntegrationFailure = () =>
  action(LinesMatrixIntegrationTypes.GET_LINE_MATRIX_INTEGRATION_FAILURE);

// Create Line Matrix Integration
export const createLineMatrixIntegrationRequest = (payload: object) =>
  asyncAction(
    LinesMatrixIntegrationTypes.CREATE_LINE_MATRIX_INTEGRATION_REQUEST,
    payload,
  );

export const createLineMatrixIntegrationSuccess = (payload: {
  lineMatrixIntegrationData: LineMatrixIntegrationInterface;
}) =>
  action(
    LinesMatrixIntegrationTypes.CREATE_LINE_MATRIX_INTEGRATION_SUCCESS,
    payload,
  );

export const createLineMatrixIntegrationFailure = () =>
  action(LinesMatrixIntegrationTypes.CREATE_LINE_MATRIX_INTEGRATION_FAILURE);

// Create Matrix Integration (Local)
export const createLineMatrixIntegration = (payload: {
  createLineMatrixIntegration: CreateLineMatrixIntegrationInterface[];
}) =>
  action(LinesMatrixIntegrationTypes.CREATE_LINE_MATRIX_INTEGRATION, payload);

// Update Line Matrix Integration
export const updateLineMatrixIntegrationRequest = (payload: object) =>
  asyncAction(
    LinesMatrixIntegrationTypes.UPDATE_LINE_MATRIX_INTEGRATION_REQUEST,
    payload,
  );

export const updateLineMatrixIntegrationSuccess = () =>
  action(LinesMatrixIntegrationTypes.UPDATE_LINE_MATRIX_INTEGRATION_SUCCESS);

export const updateLineMatrixIntegrationFailure = () =>
  action(LinesMatrixIntegrationTypes.UPDATE_LINE_MATRIX_INTEGRATION_FAILURE);

// Delete Line Matrix Integration
export const deleteLineMatrixIntegrationRequest = (payload: any) =>
  action(
    LinesMatrixIntegrationTypes.DELETE_LINE_MATRIX_INTEGRATION_REQUEST,
    payload,
  );

export const deleteLineMatrixIntegrationSuccess = () =>
  action(LinesMatrixIntegrationTypes.DELETE_LINE_MATRIX_INTEGRATION_SUCCESS);

export const deleteLineMatrixIntegrationFailure = () =>
  action(LinesMatrixIntegrationTypes.DELETE_LINE_MATRIX_INTEGRATION_FAILURE);

// Set Selected Lines
export const selectedLines = (payload: {
  selectedLines: SelectedLinesInterface[];
}) => action(LinesMatrixIntegrationTypes.SELECTED_LINES, payload);

// Set Selected Start Date
export const setSelectedStartDate = (payload: { selectedStartDate: Date }) =>
  action(LinesMatrixIntegrationTypes.SET_SELECTED_START_DATE, payload);

// Set Selected End Date
export const setSelectedEndDate = (payload: { selectedEndDate: Date }) =>
  action(LinesMatrixIntegrationTypes.SET_SELECTED_END_DATE, payload);